import { render, staticRenderFns } from "./ScreeningsList.vue?vue&type=template&id=19d2dcce&scoped=true"
import script from "./ScreeningsList.vue?vue&type=script&lang=js"
export * from "./ScreeningsList.vue?vue&type=script&lang=js"
import style0 from "./ScreeningsList.vue?vue&type=style&index=0&id=19d2dcce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d2dcce",
  null
  
)

export default component.exports